export const PROFILE_HEADER = 'ProfileHeader';
export const GAME_PROFILE_HEADER = 'GameProfileHeader';
export const ATTRIBUTES_PROMPT = 'AttributesPrompt';
